import styled, { css } from "styled-components/macro";

import {
  BREAKPOINT_DESKTOP,
  BREAKPOINT_DESKTOP_XL,
  NAV_HEIGHT_PX,
} from "../../../../constants/constants";
import { CUSTOM_SCROLLBAR_CSS } from "App/CUSTOM_SCROLLBAR_CSS";
import {
  getDashboardCardsResponsiveStyles,
  getRangeSelectorResponsiveStyles,
  getGroupMetricsResponsiveStyles,
  getOverallBarstackResponsiveStyles,
  getTrendChartResponsiveStyles,
  getTimelineChartResponsiveStyles,
  getPnlChartResponsiveStyles,
  getPnlPopupChartResponsiveStyles,
} from "../../styles/getDashboardCardsResponsiveStyles";
export const HUBLETVIEW_XL_OFFSET_TOP = 32;
export const HubletPageStyles = styled.div<{
  $scale: number;
  $isPnlPopupOpen?: boolean;
  $isRetrotagPopperOpen?: boolean;
}>`
  .datepickerAndCharts {
    position: relative;
    min-height: 100%;
    max-height: calc(100vh - ${NAV_HEIGHT_PX}px);
    box-sizing: border-box;
    padding-bottom: 120px;
  }
  @media print {
    .toggle-range-selector {
      display: none;
    }
  }
  @media screen and (min-width: ${BREAKPOINT_DESKTOP}px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    height: 100vh;
    display: flex;
    align-items: flex-start;
    [class*="DatepickerAndChartsStyles"] {
      margin-top: ${NAV_HEIGHT_PX}px;
      min-width: 50%;
      flex-grow: 1;
      flex-shrink: 999;
      ${props =>
        props.$isPnlPopupOpen
          ? css`
              overflow-y: hidden;
              min-width: calc(50% - 16px); /* scrollbar width */
              max-width: unset;
            `
          : css`
              overflow-y: auto;
              @supports (overflow: overlay) {
                overflow-y: overlay;
              }
            `};
      overflow-x: hidden;
      ${CUSTOM_SCROLLBAR_CSS}
    }
    .cardsWrapper:not(.newDatePicker) {
      margin-top: 8px;
    }
  }
  @media screen and (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    /* adding many &s here to manually increase this block's specificity,
    so that it overrides other CSS in this app without having to modify other files or to use !important */
    &&&&&&&&&&&&&&&&&&&&&&&&& {
      top: ${HUBLETVIEW_XL_OFFSET_TOP}px;
      [class*="DatepickerAndChartsStyles"] {
        margin-top: 68px;
      }

      /* DatePickerAndCharts component width (which determines props.$scale) only spans 0.5 * the screen width on Hublet Page,
      so need to double the scale for these charts to make them readable as though on a full-width page */
      ${props => getDashboardCardsResponsiveStyles(props.$scale * 2)}
      ${props => getRangeSelectorResponsiveStyles(props.$scale * 2)}
      ${props => getGroupMetricsResponsiveStyles(props.$scale * 2)}
      ${props => getOverallBarstackResponsiveStyles(props.$scale * 2)}
      ${props => getTrendChartResponsiveStyles(props.$scale * 2)}
      ${props => getPnlPopupChartResponsiveStyles(props.$scale * 2)}
      ${props => getTimelineChartResponsiveStyles(props.$scale * 2)}
      ${props => getPnlChartResponsiveStyles(props.$scale * 2)}
      .Card_PnlChart {
        padding-bottom: ${props => props.$scale * 250}px;
      }
      .trendChartWrapperHubletPage {
        height: ${p => p.$scale * 600}px !important;
        margin-top: ${p => p.$scale * 20}px !important;
      }
    }
  }
`;
